import { Card, Button, Input, TextField, Spinner } from '@heroui/react';
import { Link } from 'react-router-dom';
import { FieldLabel } from '@/components/molecules/FieldLabel';
import { useRegisterPage } from './useRegisterPage';

export function RegisterPage() {
  const {
    login,
    setLogin,
    password,
    setPassword,
    passwordConfirm,
    setPasswordConfirm,
    loading,
    error,
    handleSubmit,
  } = useRegisterPage();

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <Card className="bg-surface w-full max-w-sm">
        <div className="p-6">
          <h1 className="text-xl font-bold text-foreground mb-1">Visitor Check</h1>
          <p className="text-sm text-muted mb-6">Регистрация организации</p>
          <form onSubmit={handleSubmit} className="flex flex-col gap-4">
            <TextField variant="secondary" value={login} onChange={setLogin} isRequired>
              <FieldLabel>Логин</FieldLabel>
              <Input placeholder="my_company" autoComplete="username" />
            </TextField>
            <TextField
              variant="secondary"
              value={password}
              onChange={setPassword}
              isRequired
              type="password"
            >
              <FieldLabel>Пароль</FieldLabel>
              <Input placeholder="Минимум 6 символов" autoComplete="new-password" />
            </TextField>
            <TextField
              variant="secondary"
              value={passwordConfirm}
              onChange={setPasswordConfirm}
              isRequired
              type="password"
            >
              <FieldLabel>Повторите пароль</FieldLabel>
              <Input autoComplete="new-password" />
            </TextField>
            {error && <p className="text-sm text-danger">{error}</p>}
            <Button type="submit" size="md" isDisabled={loading}>
              {loading ? <Spinner size="sm" /> : 'Зарегистрироваться'}
            </Button>
          </form>
          <p className="mt-4 text-center text-sm text-muted">
            Уже есть аккаунт?{' '}
            <Link to="/login" className="text-link hover:underline">
              Войти
            </Link>
          </p>
        </div>
      </Card>
    </div>
  );
}
